<style lang="scss" scoped="">
  @import "../../../assets/scss/mixins";

  .len-btn {
    .icon {
      margin: 0 8px;
      cursor: pointer;
      font-size: 18px;

      &:hover {
        color: $activeColor;
      }
    }
  }

  .h2-title {
    font-size: 14px;
    margin-left: 10px;
  }
</style>
<template>
  <dialog-template :pageSets="pageSets" @selectTab="selectTab">
    <template slot="title">{{orgTitle}}信息</template>
    <template slot="btn">
      <el-button type="primary" @click="onSubmit('baseform')" :disabled="doing">保存</el-button>
    </template>
    <template slot="content">
      <form-show-part :pageSetsItem="pageSets[0]" :currentTab="currentTab">
        <template slot="content">
          <el-form ref="baseform" :rules="rules" :model="form" label-width="160px" class="min-gutter"
                   :validate-on-rule-change="false"
                   @submit.prevent="onSubmit('baseform')" onsubmit="return false" style="padding-right: 20px">
            <el-form-item :label="orgTitle+'ID'" v-show="form.id">
              {{form.id}}
            </el-form-item>
            <el-form-item :label="orgTitle+'分类'" prop="orgRelationTypeList">
              <el-select placeholder="请选择单位分类" v-model="form.orgRelationTypeList" multiple>
                <el-option :label="item.label" :value="item.key" :key="item.key"
                           v-for="item in orgRelationType"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="国家或地区（中文）" prop="countryOrRegionChinese"
                          v-if="showField([1,2,3,4,5,6,7,8,9,10,11,12])">
              <oms-input type="text" v-model="form.countryOrRegionChinese" placeholder="请输入国家或地区"
                         :disabled="isCountryOrRegionChineseDisabled"></oms-input>
            </el-form-item>
            <el-form-item label="统一社会信用代码" :prop="'creditCode'" v-if="showField([1,0,3,0,5,6,7,8,9,10,11,12])">
              <oms-input type="text" v-model="form.creditCode" placeholder="请输入统一社会信用代码"
                         :disabled="isCreditCodeDisabled" :maxlength="50"></oms-input>
            </el-form-item>
            <el-form-item :label="'系统代码'" prop="manufacturerCode"
                          v-if="form.id &&showField([1,2,3,4,5,6,7,8,9,10,11,12])">
              <oms-input type="text" v-model="form.manufacturerCode" placeholder="请输入系统代码" :maxlength="50"></oms-input>
            </el-form-item>
            <el-form-item :label="orgTitle+'名称'" prop="name" v-if="showField([1,2,3,4,5,6,7,8,9,10,11,12])">
              <oms-input type="text" v-model="form.name" placeholder="请输入名称"
                         :disabled="isManufacturerCode" :maxlength="200"></oms-input>
            </el-form-item>
            <el-form-item :label="orgTitle+'名称曽用名'" v-if="showField([1,2,3,4,5,6,7,8,9,10,11,12])">
              <oms-input type="text" v-model="form.orgUsedName" :maxlength="50" placeholder="请输入单位名称曽用名"></oms-input>
            </el-form-item>

            <el-form-item :label=" orgTitle+'名称拼音'" prop="namePhonetic" v-if="action==='edit'">
              <oms-input type="text" v-model="form.namePhonetic" placeholder="请输入通用名称拼音"></oms-input>
            </el-form-item>
            <el-form-item :label=" orgTitle+'拼音首字母'" prop="nameAcronymy" v-if="action==='edit'">
              <oms-input type="text" v-model="form.nameAcronymy" placeholder="请输入通用名称拼音首字母"></oms-input>
            </el-form-item>

            <el-form-item :label="'营业执照' + orgTitle+'类型'" prop="orgKind" v-if="showField([1,0,3,0,5,6,7,0,9,0,0,12])">
              <oms-input type="text" v-model="form.orgKind" placeholder="请输入营业执照单位类型"></oms-input>
            </el-form-item>
            <el-form-item :label="orgTitle+'所在地区'" :prop="'selectOptions'"
                          v-if="showField([1,0,3,0,5,6,7,8,9,10,11,0])">
              <el-cascader :options="options" v-model="form.selectOptions" placeholder="请选择省市区"
                           :change-on-select="true"></el-cascader>
            </el-form-item>
            <el-form-item label="乡（镇/街道办事处）" :prop="'orgTowns'" v-if="showField([1,0,3,0,5,6,7,8,9,10,11,0])">
              <oms-input type="text" v-model="form.orgTowns" :maxlength="50" placeholder="请输入乡（镇/街道办事处）"></oms-input>
            </el-form-item>
            <el-form-item label="村（街/路/弄等）" :prop="'orgVillage'" v-if="showField([1,0,3,0,5,6,7,8,9,10,11,0])">
              <oms-input type="text" v-model="form.orgVillage" :maxlength="50" placeholder="请输入村（街/路/弄等）"></oms-input>
            </el-form-item>
            <el-form-item label="门牌号码" :prop="'houseNumber'" v-if="showField([1,0,3,0,5,6,7,8,9,10,11,0])">
              <oms-input type="text" v-model="form.houseNumber" placeholder="请输入门牌号码"></oms-input>
            </el-form-item>
            <el-form-item label="住所地址" :prop="'address'" v-if="showField([1,0,3,0,5,6,7,8,0,10,11,12])">
              <oms-input type="text" placeholder="建议您如实填写详细地址,例如街道名称,门牌号码等信息" v-model="form.address"></oms-input>
            </el-form-item>
            <el-form-item label="国家或地区（英文）" v-if="showField([0,2,0,4,0,0,0,0,0,0,0,0])">
              <oms-input type="text" v-model="form.countryOrRegionEnglish" placeholder="请输入国家或地区"></oms-input>
            </el-form-item>
            <el-form-item label="公司名称(中文)" v-if="showField([0,2,0,4,0,0,0,0,0,0,0,0])">
              <oms-input type="text" v-model="form.companyChineseName" placeholder="请输入公司名称(中文)"></oms-input>
            </el-form-item>
            <el-form-item label="公司名称(英文)" v-if="showField([0,2,0,4,0,0,0,0,0,0,0,0])">
              <oms-input type="text" v-model="form.companyEnglishName" placeholder="请输入公司名称(英文)"></oms-input>
            </el-form-item>
            <el-form-item label="公司地址(中文)" v-if="showField([0,2,0,4,0,0,0,0,0,0,0,0])">
              <oms-input type="text" v-model="form.companyChineseAddress" placeholder="请输入公司地址(中文)"></oms-input>
            </el-form-item>
            <el-form-item label="公司地址(英文)" v-if="showField([0,2,0,4,0,0,0,0,0,0,0,0])">
              <oms-input type="text" v-model="form.companyEnglishAddress" placeholder="请输入公司地址(英文)"></oms-input>
            </el-form-item>

            <el-form-item label="法定代表人 /机构负责人" class="mini-line-height-label"
                          :prop="'legalRepresentative'" v-if="showField([1,0,3,0,5,6,7,8,9,10,0,0])">
              <oms-input type="text" v-model="form.legalRepresentative" :maxlength="50"
                         placeholder="请输入法定代表人 /机构负责人"></oms-input>
            </el-form-item>

            <el-form-item label="注册资本" :prop="'registeredCapital'" v-if="showField([1,0,3,0,5,6,7,0,0,0,0,0])">
              <oms-input type="text" v-model="form.registeredCapital" placeholder="请输入注册资本"></oms-input>
            </el-form-item>

            <el-form-item label="成立日期" :prop="'establishDate'" v-if="showField([1,0,3,0,5,6,7,0,0,0,0,0])">
              <el-date-picker v-model="form.establishDate" type="date" placeholder="选择成立日期" value-format="timestamp">
              </el-date-picker>
            </el-form-item>

            <el-form-item label="营业期限" :prop="'businessTerm'" v-if="showField([1,0,3,0,5,6,7,0,0,0,0,12])">
              <el-date-picker v-model="form.businessTerm" type="date" placeholder="选择营业期限" value-format="timestamp"/>
            </el-form-item>

            <el-form-item label="营业执照经营范围" :prop="'businessLicenseScope'" v-if="showField([1,0,3,0,5,6,7,0,0,0,0,0])">
              <oms-input type="text" v-model="form.businessLicenseScope" :maxlength="400"
                         placeholder="请输入营业执照经营范围"></oms-input>
            </el-form-item>

            <el-form-item label="登记机关" v-if="showField([1,0,3,0,5,6,7,0,0,0,0,0])">
              <oms-input type="text" v-model="form.registrationAuthority" placeholder="请输入登记机关"></oms-input>
            </el-form-item>

            <el-form-item label="固定电话号码" :prop="'fixedLineTelephone'" v-if="showField([1,2,3,4,5,6,7,8,9,10,11,0])">
              <oms-input type="text" v-model="form.fixedLineTelephone" :maxlength="50"
                         placeholder="请输入固定电话号码"></oms-input>
            </el-form-item>

            <el-form-item label="传真号码" v-if="showField([1,2,3,4,5,6,7,8,9,10,11,0])">
              <oms-input type="text" v-model="form.faxNumber" :maxlength="50" placeholder="请输入传真号码"></oms-input>
            </el-form-item>

            <el-form-item label="电子信箱" v-if="showField([1,2,3,4,5,6,7,8,9,10,11,0])">
              <oms-input type="text" v-model="form.electronicMail" placeholder="请输入电子信箱"></oms-input>
            </el-form-item>

            <el-form-item label="企业网址" v-if="showField([1,2,3,4,5,6,7,8,9,10,11,0])">
              <oms-input type="text" v-model="form.companyWebsite" placeholder="请输入企业网址"></oms-input>
            </el-form-item>

            <el-form-item label="联系人" :prop="'contact'" v-if="showField([1,2,3,4,5,6,7,8,9,10,11,0])">
              <oms-input type="text" v-model="form.contact" :maxlength="50" placeholder="请输入联系人"></oms-input>
            </el-form-item>
            <el-form-item label="联系电话" :prop="'phone'" v-if="showField([1,2,3,4,5,6,7,8,9,10,11,0])">
              <oms-input type="text" v-model="form.phone" :maxlength="30" placeholder="请输入联系电话"></oms-input>
            </el-form-item>
            <el-form-item label="邮政编码" v-if="showField([1,0,3,0,5,6,7,8,9,10,11,0])">
              <oms-input type="text" v-model="form.postcode" :maxlength="20" placeholder="请输入邮政编码"></oms-input>
            </el-form-item>
            <el-form-item label="接种单位编码" :prop="'inoculateOrgNo'" v-if="showField([0,0,0,0,0,0,0,0,0,10,0,0])">
              <oms-input type="text" v-model="form.inoculateOrgNo" :maxlength="50" placeholder="请输入接种单位编码"></oms-input>
            </el-form-item>
            <el-form-item label="注册地址" :prop="'registeredAddress'" v-if="showField([1,0,3,0,5,6,0,0,0,0,0,0])">
              <oms-input type="text" v-model="form.registeredAddress" placeholder="请输入注册地址"></oms-input>
            </el-form-item>
            <el-form-item label="企业负责人" :prop="'orgPrincipal'" v-if="showField([1,0,3,0,5,6,0,0,0,0,0,0])">
              <oms-input type="text" v-model="form.orgPrincipal" :maxlength="50" placeholder="请输入企业负责人"></oms-input>
            </el-form-item>
            <el-form-item label="质量负责人" :prop="'qualityPrincipal'" v-if="showField([1,0,3,0,5,6,0,0,0,0,0,0])">
              <oms-input type="text" v-model="form.qualityPrincipal" :maxlength="50" placeholder="请输入质量负责人"></oms-input>
            </el-form-item>
            <el-form-item label="许可证有效期" :prop="'licenceValidity'" v-if="showField([1,0,3,0,5,6,0,0,0,0,11,0])">
              <el-date-picker v-model="form.licenceValidity" type="date" placeholder="请选择"></el-date-picker>
            </el-form-item>
            <el-form-item label="日常监督管理机构" v-if="showField([1,0,3,0,5,6,0,0,0,0,0,0])">
              <oms-input type="text" v-model="form.supervisionOrg" placeholder="请输入日常监督管理机构"></oms-input>
            </el-form-item>
            <el-form-item label="投诉举报电话" v-if="showField([1,0,3,0,5,6,0,0,0,0,0,0])">
              <oms-input type="text" v-model="form.complaintsHotline" :maxlength="20"
                         placeholder="请输入投诉举报电话"></oms-input>
            </el-form-item>
            <el-form-item label="许可证编号" :prop="'licenceCode'" v-if="showField([1,0,3,0,5,6,0,0,0,0,11,0])">
              <oms-input type="text" v-model="form.licenceCode" :maxlength="50" placeholder="请输入许可证编号"></oms-input>
            </el-form-item>

            <el-form-item label="分类码" v-if="showField([1,0,0,0,0,0,0,0,0,0,0,0])" prop="classifyCode">
              <oms-input type="text" v-model="form.classifyCode" :maxlength="50" placeholder="请输入分类码"></oms-input>
            </el-form-item>

            <el-form-item label="生产地址" :prop="'productionAddress'" v-if="showField([1,0,3,0,0,0,0,0,0,0,0,0])">
              <oms-input type="text" v-model="form.productionAddress" placeholder="请输入生产地址"></oms-input>
            </el-form-item>
            <el-form-item label="许可证生产范围" :prop="'licenceProductionScope'" v-if="showField([1,0,3,0,0,0,0,0,0,0,0,0])">
              <oms-input type="text" v-model="form.licenceProductionScope" placeholder="请输入许可证生产范围"></oms-input>
            </el-form-item>
            <el-form-item label="经营方式" :prop="'manageMode'" v-if="showField([0,0,0,0,5,6,0,0,0,0,0,0])">
              <oms-input type="text" v-model="form.manageMode" :maxlength="50" placeholder="请输入经营方式"></oms-input>
            </el-form-item>
            <el-form-item label="仓库地址" :prop="'warehouseAddress'" v-if="showField([0,0,0,0,5,6,0,0,9,0,0,0])">
              <oms-input type="text" v-model="form.warehouseAddress" placeholder="请输入仓库地址 "></oms-input>
            </el-form-item>
            <el-form-item label="许可证经营范围" :prop="'licenceManageScope'" v-if="showField([0,0,0,0,5,6,0,0,0,0,0,0])">
              <oms-input type="text" v-model="form.licenceManageScope" placeholder="请输入许可证经营范围"></oms-input>
            </el-form-item>
            <el-form-item label="发证机关" :prop="'certifyingAuthority'" v-if="showField([1,0,3,0,5,6,0,0,0,0,0,0])">
              <oms-input type="text" v-model="form.certifyingAuthority" placeholder="请输入发证机关"></oms-input>
            </el-form-item>
            <el-form-item label="签发人" v-if="showField([1,0,3,0,5,6,0,0,0,0,0,0])">
              <oms-input type="text" v-model="form.signIssuePerson" :maxlength="20" placeholder="请输入签发人"></oms-input>
            </el-form-item>

            <el-form-item label="签发日期" :prop="'signIssueDate'" v-if="showField([1,0,3,0,5,6,0,0,0,0,0,0])">
              <el-date-picker v-model="form.signIssueDate" type="date" placeholder="请选择"></el-date-picker>
            </el-form-item>

            <el-form-item label="卫生机构代码" v-if="showField([0,0,0,0,0,0,0,0,0,0,11,0])" prop="healthAgencyCode">
              <oms-input type="text" v-model="form.healthAgencyCode" :maxlength="50"
                         placeholder="请输入卫生机构代码"></oms-input>
            </el-form-item>
            <el-form-item label="药品使用单位类型" :prop="'drugUserOrgType'" v-if="showField([0,0,0,0,0,0,0,0,0,0,11,0])">
              <el-select placeholder="请选择类型" v-model="form.drugUserOrgType">
                <el-option :label="item.label" :value="item.key" :key="item.key"
                           v-for="item in ypOrgRelationType"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="备案凭证号" prop="factoryRecordNumber" v-if="showField([0,0,3,0,0,6,0,0,0,0,0,0])">
              <oms-input type="text" v-model="form.factoryRecordNumber" :maxlength="50"
                         placeholder="请输入备案凭证号"></oms-input>
            </el-form-item>
            <!--<el-form-item label-width="140px">-->
            <!--<el-button type="primary" @click="onSubmit('baseform')" native-type="submit">保存</el-button>-->
            <!--<el-button @click="doClose">取消</el-button>-->
            <!--</el-form-item>-->
          </el-form>
        </template>
      </form-show-part>
      <form-show-part :pageSetsItem="pageSets[1]" :currentTab="currentTab">
        <template slot="content">
          <div style="margin-bottom: 40px">
            <el-row style="border-bottom: 1px solid #eee" v-for="item in licenceTypeList"
                    :key="item.objectType" v-if="showField(item.showType)">
              <h2 class="h2-title">
                <div class="left-title">{{item.name}}</div>
              </h2>
              <div style="margin-left: 20px" v-if="showField(item.showType)">
                <el-table :data="item.children">
                  <el-table-column prop="licenceNumber" label="证号" width="150">
                    <template slot-scope="scope">
                      <el-input v-model="scope.row.licenceNumber" placeholder="请输入证照编号"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column prop="validStartTime" label="生效日期" width="160">
                    <template slot-scope="scope">
                      <el-date-picker style="width: 150px" v-model="scope.row.validStartTime" format="yyyy-MM-dd"
                                      placeholder="生效日期"
                                      value-format="timestamp"/>
                    </template>
                  </el-table-column>
                  <el-table-column prop="validEndTime" label="截止日期" width="160">
                    <template slot-scope="scope">
                      <el-date-picker style="width: 150px" v-model="scope.row.validEndTime" format="yyyy-MM-dd"
                                      placeholder="截止日期"
                                      value-format="timestamp"/>
                    </template>
                  </el-table-column>
                  <el-table-column prop="licenses" label="附件">
                    <template slot-scope="scope">
                      <oms-upload :fileList="scope.row.photos" accept="image/png,image/gif,image/jpeg"
                                  @change="(files) => changeFiles(scope.row, files)" uploadUrl="/qingstor/pre"
                                  :formData="{ objectId: form.id , objectType: item.type}"></oms-upload>
                    </template>
                  </el-table-column>
                  <el-table-column prop="licenses" label="操作" width="100px">
                    <template slot-scope="scope">
                    <span class="len-btn">
                        <i class="icon el-icon-circle-plus-outline" @click="add(item)"></i>
                        <i class="icon el-icon-remove-outline" @click="deleteItem(scope.row, item)"
                           v-show="item.children.length > 1"></i>
                    </span>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-row>
          </div>
        </template>
      </form-show-part>
    </template>
  </dialog-template>
</template>

<script>
  /* eslint-disable object-shorthand */
  import {BaseInfo, orgLicence, User} from '@/resources';
  import utils from '@/tools/utils';
  import axios from 'axios';
  import ScrollMixin from '@/mixins/scrollMixin';

  export default {
    components: {
    },
    mixins: [ScrollMixin],
    props: {
      formItem: {
        type: Object,
        default: {},
        required: true
      },
      title: {
        type: String,
        default: '增加'
      },
      action: {
        type: String,
        default: ''
      },
      orgTitle: {
        type: String,
        default: '货主'
      },
      licenses: Array
    },
    data: function () {
      let checkEmail = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入邮箱'));
        } else {
          let re = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/ig;
          if (!re.test(value)) {
            callback(new Error('请输入正确的邮箱'));
          }
          if (this.action === 'edit') {
            let orgId = this.$route.params.id;
            User.checkEmail(value, this.form.adminId, orgId).then(function (res) {
              if (res.data.valid) {
                callback();
              } else {
                callback(new Error('邮箱已经存在'));
              }
            });
          } else {
            callback();
          }

        }
      };
      let checkPhone = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入座机电话号码'));
        } else {
          let re = /^(0\d{2,3}-?)?\d{7,8}$/ig;
          if (!re.test(value)) {
            callback(new Error('请输入正确的座机电话号码'));
          } else {
            callback();
          }
        }
      };
      let checkTelePhone = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入手机号码'));
        } else {
          let re = /^1[345789]\d{9}$/;
          if (!re.test(value)) {
            callback(new Error('请输入正确的手机号码'));
          }
          if (this.action === 'edit') {
            let orgId = this.$route.params.id;
            User.checkPhone(value, this.form.adminId, orgId).then(function (res) {
              if (res.data.valid) {
                callback();
              } else {
                callback(new Error('手机号码已经存在'));
              }
            });
          } else {
            callback();
          }
        }
      };
      let checkName = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入单位名称'));
        } else {
          BaseInfo.checkName(value, this.form.id).then(function (res) {
            if (res.data.valid) {
              callback();
            } else {
              callback(new Error('单位名称已经存在'));
            }
          });
        }
      };
      let checkManufacturerCode = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入系统代码'));
        } else {
          BaseInfo.checkManufacturerCode(value, this.form.id).then(function (res) {
            if (res.data.valid) {
              callback();
            } else {
              callback(new Error('系统代码已经存在'));
            }
          });
        }
      };
      let checkAdminAccount = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入管理员账号'));
        } else {
          BaseInfo.checkAdminAccount(value, this.form.id).then(function (res) {
            if (res.data.valid) {
              callback();
            } else {
              callback(new Error('管理员账号已经存在'));
            }
          });
        }
      };
      let checkCreditCode = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入统一社会信用代码'));
        } else {
          BaseInfo.checkCreditCode(value, this.form.id).then(function (res) {
            if (res.data.valid) {
              callback();
            } else {
              callback(new Error('统一社会信用代码已经存在'));
            }
          });
        }
      };
      const rules = {
        orgRelationTypeList: [
          {required: true, type: 'array', message: '请选择单位分类', trigger: 'change'}
        ],
        name: [
          {required: true, message: '请输入单位名称', trigger: 'blur'},
          {validator: checkName, trigger: 'blur'}
        ],
        orgUsedName: [
          {required: true, message: '请输入单位名称曽用名', trigger: 'blur'},
        ],
        orgAreaCode: [
          {required: true, message: '请输入区域代码', trigger: 'blur'}
        ],
        manufacturerCode: [
          {required: true, message: '请输入系统代码', trigger: 'blur'},
          {validator: checkManufacturerCode, trigger: 'blur'}
        ],
        adminAccount: [
          {required: true, message: '请输入管理员账号', trigger: 'blur'},
          {validator: checkAdminAccount, trigger: 'blur'}
        ],
        email: [
          {required: true, message: '请输入邮箱', trigger: 'blur'},
          {validator: checkEmail, trigger: 'blur'}
        ],
        adminTelephone: [
          {required: true, message: '请输入管理员手机号码', trigger: 'blur'},
          {validator: checkTelePhone, trigger: 'blur'}
        ],
        adminEmail: [
          {required: true, message: '请输入管理员邮箱', trigger: 'blur'},
          {validator: checkEmail, trigger: 'blur'}
        ],
        defaultCentreId: [
          {required: true, message: '请选择默认物流中心', trigger: 'blur'}
        ],
        orgKind: [
          {required: true, message: '请输入营业执照单位类型', trigger: 'blur'}
        ],
        namePhonetic: [
          {required: true, message: '请输入单位名称拼音', trigger: 'blur'}
        ],
        nameAcronymy: [
          {required: true, message: '请输入单位拼音首字母', trigger: 'blur'}
        ],
        countryOrRegionChinese: [
          {required: true, message: '请输入国家或地区（中文）', trigger: 'blur'}
        ],
        instrumentProductionCertificate: [
          {required: true, message: '请输入器械生产许可证号', trigger: 'blur'}
        ],
        instrumentProductionCertificateValidity: [
          {required: true, message: '请输入器械生产许可证号有效期', trigger: 'change'}
        ],
        factoryRecordNumber: [
          {required: true, message: '请输入备案凭证号', trigger: 'blur'}
        ],
        creditCode: [
          {required: true, message: '请输入统一社会信用代码', trigger: 'blur'},
          {validator: checkCreditCode, trigger: 'blur'}
        ],
        selectOptions: [
          {required: true, message: '请输入单位所在地区', trigger: 'change'}
        ],
        orgTowns: [
          {required: true, message: '请输入乡（镇/街道办事处）', trigger: 'blur'}
        ],
        orgVillage: [
          {required: true, message: '请输入村（街/路/弄等）', trigger: 'blur'}
        ],
        houseNumber: [
          {required: true, message: '请输入门牌号码', trigger: 'blur'}
        ],
        address: [
          {required: true, message: '请输入所在地区', trigger: 'blur'}
        ],
        legalRepresentative: [
          {required: true, message: '请输入法定代表人 /机构负责人', trigger: 'blur'}
        ],
        registeredCapital: [
          {required: true, message: '请输入注册资本', trigger: 'blur'}
        ],
        establishDate: [
          {required: true, message: '请输入成立日期', trigger: 'change'}
        ],
        businessTerm: [
          {required: true, message: '请输入营业期限', trigger: 'change'}
        ],
        businessLicenseScope: [
          {required: true, message: '请输入营业执照经营范围', trigger: 'blur'}
        ],
        fixedLineTelephone: [
          {required: true, message: '请输入固定电话号码', trigger: 'blur'}
        ],
        contact: [
          {required: true, message: '请输入联系人', trigger: 'blur'}
        ],
        phone: [
          {required: true, message: '请输入联系电话', trigger: 'blur'}
        ],
        inoculateOrgNo: [
          {required: true, message: '请输入接种单位编码', trigger: 'blur'}
        ],
        registeredAddress: [
          {required: true, message: '请输入注册地址', trigger: 'blur'}
        ],
        orgPrincipal: [
          {required: true, message: '请输入企业负责人', trigger: 'blur'}
        ],
        qualityPrincipal: [
          {required: true, message: '请输入质量负责人', trigger: 'blur'}
        ],
        licenceValidity: [
          {required: true, message: '请选择许可证有效期', trigger: 'change'}
        ],
        licenceCode: [
          {required: true, message: '请输入许可证编号', trigger: 'blur'}
        ],
        classifyCode: [
          {required: true, message: '请输入分类码', trigger: 'blur'}
        ],
        productionAddress: [
          {required: true, message: '请输入生产地址', trigger: 'blur'}
        ],
        licenceProductionScope: [
          {required: true, message: '请输入许可证生产范围', trigger: 'blur'}
        ],
        manageMode: [
          {required: true, message: '请输入经营方式', trigger: 'blur'}
        ],

        warehouseAddress: [
          {required: true, message: '请输入仓库地址', trigger: 'blur'}
        ],
        licenceManageScope: [
          {required: true, message: '请输入许可证经营范围', trigger: 'blur'}
        ],
        certifyingAuthority: [
          {required: true, message: '请输入发证机关', trigger: 'blur'}
        ],
        signIssueDate: [
          {required: true, message: '请输入签发日期', trigger: 'change'}
        ],
        healthAgencyCode: [
          {required: true, message: '请输入卫生机构代码', trigger: 'change'}
        ],
        drugUserOrgType: [
          {required: true, message: '请输入药品使用单位类型', trigger: 'change'}
        ],
        countryOrRegionEnglish: [
          {required: true, message: '请输入国家或地区（英文）', trigger: 'blur'}
        ],
        companyChineseName: [
          {required: true, message: '请输入公司名称(中文)', trigger: 'blur'}
        ],
        companyEnglishName: [
          {required: true, message: '请输入公司名称(英文)', trigger: 'blur'}
        ],
        companyChineseAddress: [
          {required: true, message: '请输入公司地址(中文)', trigger: 'blur'}
        ],
        companyEnglishAddress: [
          {required: true, message: '请输入公司地址(英文)', trigger: 'blur'}
        ]
      };
      return {
        orgType: this.$route.meta.type,
        form: {
          orgRelationTypeList: [],
          countryOrRegionChinese: '中国'
        },
        options: utils.address,
        doing: false,
        photo: {},
        rules: rules,
        rulesCopy: rules,
        LogisticsCompanies: [],
        isCountryOrRegionChineseDisabled: false,
        isCreditCodeDisabled: false,
        isManufacturerCode: false,
        currentTab: {},
        licenceTypeList: []
      };
    },
    mounted: function () {

    },
    computed: {
      orgClassify() {
        return this.$getDict('orgClassify');
      },
      orgLevel() {
        return this.$getDict('orgLevel');
      },
      orgRelationType() {
        return this.$store.state.orgRelationType;
      },
      ypOrgRelationType() {
        return this.$getDict('ypOrgRelationType');
      },
      LogisticsCenter() {
        return this.$store.state.logisticsCenterList || [];
      },
      isDisabled() {
        return !!this.form.id;
      },
      pageSets() {
        let ary = [
          {name: '基本信息', key: 0}
        ];
        if (this.showField([1, 3, 5, 6, 7, 8, 9, 11])) {
          ary.push({name: '单位证照', key: 1});
        }
        return ary;
      }
    },
    watch: {
      formItem: function (val) {
        this.scrollTop();
        this.isCountryOrRegionChineseDisabled = false;
        this.isCreditCodeDisabled = false;
        this.isManufacturerCode = false;

        if (val.id) {
          // this.form.selectOptions = [];
          // this.form = Object.assign({}, val);
          // if (!this.form.orgRelationTypeList) {
          //   this.form.orgRelationTypeList = [];
          // }
          // // this.orgRelationTypeList = this.form.orgRelationTypeList;
          // if (!this.form.plateList || !this.form.plateList.length) {
          //   this.form.plateList = [{orgPlateNumber: ''}];
          // }
          // this.isCountryOrRegionChineseDisabled = this.form.countryOrRegionChinese !== '0';
          // this.isCreditCodeDisabled = this.form.creditCode !== '0';
          // this.isManufacturerCode = this.form.name !== '0';
          //
          // this.form.selectOptions = utils.formatAddressByType(this.form.province, this.form.city, this.form.region);
          //
          // let licenceTypeList = JSON.parse(JSON.stringify(this.$store.state.licenceTypeList));
          // let licenses = JSON.parse(JSON.stringify(this.licenses));
          // licenceTypeList.forEach(i => {
          //   licenses.forEach(i => {
          //     if (i.photos) {
          //       i.photos.forEach(p => {
          //         p.name = p.attachmentFileName;
          //       });
          //     }
          //     i.attachmentIdList = i.photos ? i.photos.map(m => m.attachmentId) : [];
          //   });
          //   i.children = licenses.filter(f => f.licenceType === i.type);
          //   if (!i.children.length) {
          //     i.children = [JSON.parse(JSON.stringify(this.$store.state.licenceTypeFormItem))];
          //   }
          // });
          // this.licenceTypeList = JSON.parse(JSON.stringify(licenceTypeList));
        } else {
          let licenceTypeList = JSON.parse(JSON.stringify(this.$store.state.licenceTypeList));
          licenceTypeList.forEach(i => {
            i.children = [JSON.parse(JSON.stringify(this.$store.state.licenceTypeFormItem))];
          });
          this.licenceTypeList = licenceTypeList;
          this.photo = {};
          this.form.selectOptions = [];
          this.form = {
            address: '',
            orgAreaCode: '',
            adminAccount: '',
            adminEmail: '',
            adminId: '',
            adminName: '',
            adminTelephone: '',
            auditedBy: '',
            auditedStatus: '',
            auditedTime: '',
            contact: '',
            createTime: '',
            createdBy: '',
            creditCode: '',
            defaultCenter: '',
            defaultCentreId: '',
            deleteFlag: false,
            id: '',
            legalRepresentative: '',
            level: '',
            manufacturerCode: '',
            name: '',
            nameJc: '',
            namePhonetic: '',
            orgAuditStatus: '',
            orgPhoto: '',
            orgPhotoId: '',
            phone: '',
            postcode: '',
            province: '',
            city: '',
            region: '',
            relationList: [],
            remarks: '',
            type: '',
            updateTime: '',
            logisticsCompany: '',
            transportationTime: '',
            plateList: [
              {orgPlateNumber: ''}
            ],
            orgScanCode: false,
            orgOutScanCode: false,
            skipFlag: false,
            extDto: {
              id: '',
              licensePlateNumber: '',
              transportTimeLimit: '',
              logisticsDealer: ''
            },
            orgRelationTypeList: [],
            selectOptions: [],
            countryOrRegionChinese: '中国'
          };
          this.form.extDto = Object.assign({}, {
            id: '',
            licensePlateNumber: '',
            transportTimeLimit: '',
            logisticsDealer: ''
          }, val.extDto);
        }
        this.$nextTick(() => {
          this.$refs.baseform && this.$refs.baseform.clearValidate();
        });
      },
      'form.selectOptions': function () {
        let selectOptions = utils.formatAddressByType(this.form.selectOptions[0],
          this.form.selectOptions[1], this.form.selectOptions[2], 'label');
        this.form.province = selectOptions[0] || '';
        this.form.city = selectOptions[1] || '';
        this.form.region = selectOptions[2] || '';
      },
      'form.creditCode': function (val) {
        if (val) {
          this.form.creditCode = val.toUpperCase();
        }
      },
      isRequired(val) {
        this.$refs.baseform && this.$refs.baseform.clearValidate();
      }
    },
    methods: {
      add(item) {
        item.children.push(JSON.parse(JSON.stringify(this.$store.state.licenceTypeFormItem)));
      },
      deleteItem(row, item) {
        if (!row.id) {
          item.children = item.children.filter(f => f !== row);
        } else {
          orgLicence.delete(row.id).then(() => {
            item.children = item.children.filter(f => f !== row);
          }).catch(() => {
            this.$notify.error('单位证照删除失败');
          });
        }
      },
      selectTab(item) {
        this.currentTab = item;
      },
      showField(arr) {
        return this.form.orgRelationTypeList.some(s => arr.some(a => (a + '') === s));
      },
      saveAttachment(orgId) {
        if (!orgId) return;
        this.licenceTypeList.forEach(i => {
          if (!this.showField(i.showType)) return;
          i.children.forEach(c => {
            c.orgId = orgId;
            c.licenceType = i.type;
            if (c.id) {
              orgLicence.update(c.id, c).catch(() => {
                this.$notify.error('单位证照保存失败');
              });
            } else {
              orgLicence.save(c).catch(() => {
                this.$notify.error('单位证照保存失败');
              });
            }
          });
        });
      },
      checkAttachment() {
        let valid = true;
        for (let item of this.licenceTypeList) {
          if (!this.showField(item.showType)) continue;
          for (let child of item.children) {
            if (!child.validStartTime) {
              this.$notify.info('请选择生效日期');
              valid = false;
              return valid;
            }
            if (!child.validEndTime) {
              this.$notify.info('请选择截止日期');
              valid = false;
              return valid;
            }
            if (child.validEndTime < child.validStartTime) {
              this.$notify.info('截止日期必须大于生效日期');
              valid = false;
              return valid;
            }
            if (!child.attachmentIdList.length) {
              this.$notify.info('请选择附件');
              valid = false;
              return valid;
            }
          }
        }
        return valid;
      },
      changeFiles: function (item, fileList) {
        let ids = [];
        fileList.forEach(file => {
          ids.push(file.attachmentId);
        });
        item.attachmentIdList = ids;
      },
      onSubmit: function (formName) {
        if (!this.form.city) {
          this.form.city = '';
        }
        if (!this.form.region) {
          this.form.region = '';
        }

        let self = this;
        this.$refs[formName].validate((valid) => {
          if (!valid || this.doing) {
            return false;
          }
          if (!this.checkAttachment()) return;
          this.doing = true;
          // this.form.orgRelationTypeList = this.orgRelationTypeList;
          this.form.orgAreaCode = this.form.selectOptions[this.form.selectOptions.length - 1] || '';
          if (this.action === 'add') {
            self.form.type = this.$route.meta.type;
            BaseInfo.save(self.form).then(res => {
              this.doing = false;
              this.$notify.success({
                duration: 2000,
                name: '成功',
                message: '新增"' + this.orgTitle + self.form.name + '"成功'
              });
              this.saveAttachment(res.data.id);
              self.$emit('change', Object.assign({}, self.form));
            }).catch(error => {
              this.doing = false;
              this.$notify.error({
                duration: 2000,
                name: '失败',
                message: error.response.data && error.response.data.msg || '新增失败'
              });
            });
          } else {
            let plates = self.form.plateList.filter(f => f.orgPlateNumber).map(m => {
              return {
                orgPlateNumber: m.orgPlateNumber,
                orgId: self.form.id
              };
            });
            axios.all([BaseInfo.update(self.form.id, self.form)]).then(axios.spread(() => {
              this.doing = false;
              this.$notify.success({
                duration: 2000,
                name: '成功',
                message: '修改' + this.orgTitle + '基础信息"' + self.form.name + '"成功'
              });
              this.saveAttachment(self.form.id);
              self.$emit('change', Object.assign({}, self.form));
            })).catch(error => {
              this.doing = false;
              this.$notify.error({
                duration: 2000,
                name: '失败',
                message: error.response.data && error.response.data.msg || '修改' + this.orgTitle + '基础信息"' + self.form.name + '"失败'
              });
            });
          }
        });
      },
      doClose: function () {
        this.$emit('close');
        this.$refs['baseform'].resetFields();
      }
    }
  };
</script>
